export function TailwindScreenIndicator() {
    if (process.env.NODE_ENV !== 'development') return null;

    return (
        <div className='grid h-6 cursor-help place-content-center rounded bg-gray-800 px-2 font-mono text-xs/1 text-white uppercase opacity-30 select-none hover:opacity-100'>
            <div className='block sm:hidden'>xs</div>
            <div className='hidden sm:block md:hidden lg:hidden xl:hidden 2xl:hidden'>sm</div>
            <div className='hidden md:block lg:hidden xl:hidden 2xl:hidden'>md</div>
            <div className='hidden lg:block xl:hidden 2xl:hidden'>lg</div>
            <div className='hidden xl:block 2xl:hidden'>xl</div>
            <div className='hidden 2xl:block'>2xl</div>
        </div>
    );
}
